import { fetchWithAuth } from './fetchWithAuth';

const BASE_URL = process.env.REACT_APP_API_URL || '/api';

// ==================== 마스터 (관리자) ====================

export const getSurveyList = async (survey_year) => {
  return fetchWithAuth(`/survey?survey_year=${survey_year}`);
};

export const getSurvey = async (survey_year, seq_no) => {
  return fetchWithAuth(`/survey/${survey_year}/${seq_no}`);
};

export const createSurvey = async (body) => {
  return fetchWithAuth(`/survey`, { method: 'POST', body: JSON.stringify(body) });
};

export const updateSurvey = async (survey_year, seq_no, body) => {
  return fetchWithAuth(`/survey/${survey_year}/${seq_no}`, { method: 'PUT', body: JSON.stringify(body) });
};

export const deleteSurvey = async (survey_year, seq_no) => {
  return fetchWithAuth(`/survey/${survey_year}/${seq_no}`, { method: 'DELETE' });
};

export const updateSurveyStatus = async (survey_year, seq_no, status) => {
  return fetchWithAuth(`/survey/${survey_year}/${seq_no}/status`, {
    method: 'PATCH', body: JSON.stringify({ status }),
  });
};

// ==================== 항목 (관리자) ====================

export const getSurveyItems = async (survey_year, seq_no) => {
  return fetchWithAuth(`/survey/${survey_year}/${seq_no}/items`);
};

export const saveSurveyItems = async (survey_year, seq_no, items) => {
  return fetchWithAuth(`/survey/${survey_year}/${seq_no}/items`, {
    method: 'POST', body: JSON.stringify({ items }),
  });
};

// ==================== 결과 (관리자) ====================

export const getSurveyResult = async (survey_year, seq_no) => {
  return fetchWithAuth(`/survey/${survey_year}/${seq_no}/result`);
};

// 엑셀 다운로드 - fetchWithAuth는 res.json()을 반환하므로 별도 처리 (파일 다운로드는 blob 필요)
export const downloadSurveyExcel = async (survey_year, seq_no) => {
  const res = await fetch(`${BASE_URL}/survey/${survey_year}/${seq_no}/excel`, {
    headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
  });
  if (!res.ok) throw new Error('엑셀 다운로드 실패');

  const blob = await res.blob();
  const url = window.URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = `survey_${survey_year}_${seq_no}.xlsx`;
  document.body.appendChild(a);
  a.click();
  a.remove();
  window.URL.revokeObjectURL(url);
};

// ==================== 응답 (조합원, 비로그인) ====================

export const getForResponse = async (branchCode, divisionCode, survey_year, seq_no) => {
  const res = await fetch(
    `${BASE_URL}/survey/${survey_year}/${seq_no}/response?branch_code=${branchCode}&division_code=${divisionCode}`
  );
  return res.json();
};

export const submitAnswer = async (branchCode, divisionCode, survey_year, seq_no, answers) => {
  const res = await fetch(`${BASE_URL}/survey/response`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ branch_code: branchCode, division_code: divisionCode, survey_year, seq_no, answers }),
  });
  return res.json();
};

// ==================== 응답 (조합원, 로그인) ====================
export const getForMemberResponse = async (survey_year, seq_no) => {
  return fetchWithAuth(`/survey/${survey_year}/${seq_no}/member-response`);
};

export const submitMemberAnswer = async (survey_year, seq_no, answers) => {
  return fetchWithAuth(`/survey/${survey_year}/${seq_no}/member-response`, {
    method: 'POST', body: JSON.stringify({ answers }),
  });
};

export const copySurvey = async (survey_year, seq_no) => {
  return fetchWithAuth(`/survey/${survey_year}/${seq_no}/copy`, { method: 'POST' });
};